var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-dispute" },
    [
      _c("div", { staticClass: "contract-dispute__header" }, [
        _c("h2", { staticClass: "contract-dispute__header-title" }, [
          _vm._v(_vm._s(_vm.i18n.cont_dispute_information()))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contract-dispute__wrapper" },
        [
          _c("div", { staticClass: "contract-dispute__details-row" }, [
            _c("div", { staticClass: "contract-dispute__document-name" }, [
              _c("h3", [_vm._v(_vm._s(_vm.i18n.lbl_documents()))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contract-dispute__document-submitter" }, [
              _c("h3", [_vm._v(_vm._s(_vm.i18n.lbl_submitted_by()))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contract-dispute__document-type" }, [
              _c("h3", [_vm._v(_vm._s(_vm.i18n.lbl_type()))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contract-dispute__documents-view-btn" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contract-dispute__details-row" }, [
            _c("div", { staticClass: "contract-dispute__document-name" }, [
              _c("i", { staticClass: "document-icon material-icons" }, [
                _vm._v("note")
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.disputeFile.name))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "contract-dispute__document-submitter" },
              [_c("email-getter", { attrs: { id: _vm.dispute.author } })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "contract-dispute__document-type" }, [
              _c("p", [_vm._v(_vm._s(_vm.disputeFile.type))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contract-dispute__documents-view-btn" }, [
              _c("a", { attrs: { href: _vm.getUrl, target: "_blank" } }, [
                _vm._v(_vm._s(_vm.i18n.lbl_open()))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.lbl_note(),
              value: _vm.disputeDetails.note,
              alignLeft: true,
              colWidth: [15, 85],
              keyTextColor: "$col-text-bright",
              valueTextColor: "$col-text-bright"
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.notes, function(item, i) {
            return [
              _c(
                "div",
                { key: i, staticClass: "contract-dispute__escrow-appeal-row" },
                [
                  item.author !== _vm.escrow
                    ? _c(
                        "h3",
                        [
                          _vm._v(
                            _vm._s(_vm.i18n.cont_appeal_escrow_by()) +
                              "\n          "
                          ),
                          _c("email-getter", { attrs: { id: item.author } })
                        ],
                        1
                      )
                    : _c("h3", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.i18n.cont_escrow_resolution()) +
                            "\n        "
                        )
                      ]),
                  _vm._v(" "),
                  _c("detail-row", {
                    staticClass: "contract-dispute__note-row",
                    attrs: {
                      prop: _vm.i18n.lbl_note(),
                      value: item.details.note,
                      alignLeft: true,
                      colWidth: [15, 85]
                    }
                  })
                ],
                1
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contract-dispute__action-wrapper" },
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              attrs: { disabled: _vm.isPending || _vm.hasAppealed },
              on: {
                click: function($event) {
                  _vm.isAppealingEscrow = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.i18n.cont_appeal_to_escrow()))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isAppealingEscrow
        ? _c(
            "modal",
            {
              attrs: { maxWidth: "600px" },
              on: {
                "close-request": function($event) {
                  _vm.isAppealingEscrow = false
                }
              }
            },
            [
              _c("appeal-escrow", {
                attrs: { contractId: _vm.contractId },
                on: { "load-contract": _vm.loadContract }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dac32ae8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dac32ae8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/Contracts.Dispute.vue
// module id = wclM
// module chunks = 1